import React from "react";
import PropTypes from "prop-types";

import { linkTargets, sitewideBannerTypes } from "core/props";

import CloseButton from "./CloseButton";
import { BannerContainer, BannerInnerContainer, BannerContent } from "./styles";

const PromotionBanner = ({
    type = "promotional",
    bannerKey,
    promoCode,
    href,
    hrefTarget = "_self",
    textBeforePromoCode,
    textAfterPromoCode,
    bannerDismiss
}) => {
    return (
        <BannerContainer
            type={type}
            data-callback={`accounts/hide-banner/${bannerKey}`}
            data-banner-show-anonymous="true"
            data-banner-key={type}
        >
            <BannerContent>
                <BannerInnerContainer>
                    <div>
                        {textBeforePromoCode}
                        <a
                            href={href}
                            title="More information"
                            target={hrefTarget}
                        >
                            {promoCode}
                        </a>
                        {textAfterPromoCode}
                    </div>
                </BannerInnerContainer>
            </BannerContent>

            <CloseButton bannerDismiss={bannerDismiss} />
        </BannerContainer>
    );
};

PromotionBanner.propTypes = {
    bannerKey: PropTypes.string.isRequired,
    type: PropTypes.oneOf(sitewideBannerTypes),
    promoCode: PropTypes.string,
    href: PropTypes.string,
    hrefTarget: PropTypes.oneOf(linkTargets),
    textBeforePromoCode: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    textAfterPromoCode: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    bannerDismiss: PropTypes.func
};

export default PromotionBanner;
